import React from 'react';

// Category tiles for the "Our ethical marketplace sells everything" section.
// Line icons are drawn inline (from the refreshed design mockup) so the section
// needs no image assets. Labels are resolved from en.json via their `labelId`.
// `category` is the key of the 'category' listing field (see
// src/config/configCategories.js): each tile links to the search page
// filtered by it.
//
// The order below is alphabetical with 'Other' last, so the tiles read in the
// same order as the category dropdown and the search filter (Jira P25028-115).
// It has to be kept in step by hand: the icons are what makes a tile, so the
// list cannot be generated from the config.

const svgProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const LANDING_CATEGORIES = [
  {
    category: 'art',
    labelId: 'CustomLandingPage.categories.label.art',
    icon: (
      <svg {...svgProps}>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.5" />
      </svg>
    ),
  },
  {
    category: 'books',
    labelId: 'CustomLandingPage.categories.label.books',
    icon: (
      <svg {...svgProps}>
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </svg>
    ),
  },
  {
    category: 'electronics',
    labelId: 'CustomLandingPage.categories.label.electronics',
    icon: (
      <svg {...svgProps}>
        <rect x="3" y="4" width="18" height="14" rx="2" />
        <path d="M8 22h8M12 18v4" />
      </svg>
    ),
  },
  {
    category: 'fashion',
    labelId: 'CustomLandingPage.categories.label.fashion',
    icon: (
      <svg {...svgProps}>
        <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
      </svg>
    ),
  },
  {
    category: 'furniture',
    labelId: 'CustomLandingPage.categories.label.furniture',
    icon: (
      <svg {...svgProps}>
        <path d="M3 9V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4M3 13v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6M3 13h18M7 21v-2M17 21v-2" />
      </svg>
    ),
  },
  {
    category: 'health-and-beauty',
    labelId: 'CustomLandingPage.categories.label.healthAndBeauty',
    icon: (
      <svg {...svgProps}>
        <path d="M4 8a4 4 0 1 1 8 0v8a4 4 0 1 1-8 0zM12 8a4 4 0 1 1 8 0v8a4 4 0 1 1-8 0z" />
      </svg>
    ),
  },
  {
    category: 'home-and-garden',
    labelId: 'CustomLandingPage.categories.label.homeAndGarden',
    icon: (
      <svg {...svgProps}>
        <path d="M3 9.5 12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" />
      </svg>
    ),
  },
  {
    category: 'jewellery',
    labelId: 'CustomLandingPage.categories.label.jewellery',
    icon: (
      <svg {...svgProps}>
        <circle cx="12" cy="12" r="3" />
        <path d="M5 8l2-4h10l2 4M3 14l9 8 9-8" />
      </svg>
    ),
  },
  {
    category: 'mother-and-baby',
    labelId: 'CustomLandingPage.categories.label.motherAndBaby',
    icon: (
      <svg {...svgProps}>
        <path d="M9 12h.01M15 12h.01M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5M12 3c5 0 9 4 9 9v9H3v-9a9 9 0 0 1 9-9z" />
      </svg>
    ),
  },
  {
    category: 'toys',
    labelId: 'CustomLandingPage.categories.label.toys',
    icon: (
      <svg {...svgProps}>
        <rect x="8" y="3" width="8" height="8" rx="1" />
        <rect x="3" y="13" width="8" height="8" rx="1" />
        <rect x="13" y="13" width="8" height="8" rx="1" />
      </svg>
    ),
  },
  {
    category: 'other',
    labelId: 'CustomLandingPage.categories.label.other',
    icon: (
      <svg {...svgProps}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9 9h.01M15 9h.01M8 14a4 4 0 0 0 8 0" />
      </svg>
    ),
  },
];
